var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"医院岗位设置管理","request":_vm.request,"column-list":_vm.columnList,"dealFormData":_vm.dealFormData,"table-size":"large","tableActionsFixed":true,"form-parms-add":_vm.formParmsAdd,"form-parms-update":_vm.formParmsUpdate,"need-data-file":true},on:{"dataUpdate":_vm.dataUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }